var map = {
	"./background-app-shop-blue.jpg": "1493",
	"./background-app-shop-dark.jpg": "eeb0",
	"./background-app-shop.jpg": "0fa2",
	"./bg-device.png": "65fb",
	"./bg_custom1.jpg": "5022",
	"./bg_custom2.jpg": "339b",
	"./logo.jpg": "64dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0949";